export const BILLING_UPSELL_EVENT = 'tasklina:billing-upsell';

const itemLabels = {
  trial_expired: 'Premium workspace features',
  max_projects: 'Projects',
  max_tasks_per_project: 'Tasks per project',
  max_subtasks_per_task: 'Subtasks',
  max_attachments_per_task: 'Task attachments',
  max_storage_gb: 'Storage',
  max_file_size_mb: 'File upload size',
  max_ai_queries: 'AI credits',
  max_departments: 'Departments',
  org_seat: 'Team seats',
  team_workspaces: 'Team workspaces',
  guest_access: 'Guest access',
  google_calendar_sync: 'Google Calendar sync',
  kanban_view: 'Board view',
  timeline_view: 'Timeline / Gantt view',
  sticky_notes: 'Sticky Notes',
  audit_logs: 'Activity history',
  data_export: 'Data export',
  module_finance: 'Finance module',
  module_marketing: 'Marketing module',
  project_discussions: 'Project discussions',
  email_realtime: 'Realtime email notifications'
};

export function getBillingItemLabel(itemId, fallback = 'this feature') {
  if (!itemId) return fallback;
  return itemLabels[itemId] || fallback;
}

export function getWorkspaceUpgradeUrl(workspaceType) {
  return workspaceType === 'organization' ? '/org/billing' : '/billing';
}

export function normalizeBillingUpsellDetail(detail = {}) {
  const itemId = detail.itemId || detail.meta?.itemId || null;
  const workspaceType = detail.workspaceType || detail.meta?.workspaceType || 'personal';
  const feature = detail.feature || detail.featureName || getBillingItemLabel(itemId);
  const current = detail.current ?? detail.used ?? detail.meta?.current ?? detail.meta?.used;
  const limit = detail.limit ?? detail.meta?.limit;

  return {
    code: detail.code || detail.billingCode || null,
    itemId,
    feature,
    message: detail.message || detail.error || detail.billingMessage || null,
    limit,
    current,
    used: detail.used ?? detail.current ?? detail.meta?.used,
    resetAt: detail.resetAt || detail.meta?.resetAt || null,
    workspaceType,
    upgradeUrl: detail.upgradeUrl || detail.meta?.upgradeUrl || getWorkspaceUpgradeUrl(workspaceType)
  };
}

export function openBillingUpsell(detail) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(BILLING_UPSELL_EVENT, {
    detail: normalizeBillingUpsellDetail(detail)
  }));
}
